<template>
  <div class="carregando">
    <svg viewBox="0 0 441 480" xmlns="http://www.w3.org/2000/svg">
      <path d="M205.929 445.924C319.661 445.924 411.859 353.726 411.859 239.994C411.859 126.263 319.661 34.0649 205.929 34.0649C92.1977 34.0649 0 126.263 0 239.994C0 353.726 92.1977 445.924 205.929 445.924Z" stroke="var(--cor-branco)" stroke-width="2" />
      <path d="M91.7706 2.28977C82.6485 -3.72857 70.4888 2.81967 70.4888 13.7492V466.251C70.4888 477.18 82.6485 483.729 91.7706 477.71L434.768 251.455C442.992 246.032 442.992 233.967 434.768 228.536L91.7706 2.28029V2.28977ZM203.753 167.936C223.966 166.659 240.63 183.323 239.352 203.535C238.302 220.199 224.77 233.731 208.106 234.781C187.894 236.059 171.23 219.395 172.507 199.182C173.558 182.518 187.08 168.986 203.753 167.936ZM229.435 312.13H182.424C164.814 312.13 150.544 297.86 150.544 280.25C150.544 262.64 164.814 248.37 182.424 248.37H229.435C247.046 248.37 261.315 262.64 261.315 280.25C261.315 297.86 247.046 312.13 229.435 312.13Z" stroke="var(--cor-branco)" stroke-width="2" />
    </svg>
  </div>
</template>

<script setup></script>

<style scoped>
.carregando {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  z-index: 10;
  background-color: var(--cor-preto);
  transition: all 1s;
}
.carregando.ocultar {
  top: 100dvh;
  pointer-events: none;
}
svg {
  width: 100px;
}
svg path {
  fill: none;
  stroke-width: 2;
  stroke-dasharray: 300;
  stroke-dashoffset: 100;
  animation: desenhar 10s linear infinite;
}
.um {
  animation-delay: 0s;
}
.dois {
  animation-delay: 0.3s;
}
@keyframes desenhar {
  0% {
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dashoffset: 900;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
</style>
